import { useWeb3ModalProvider } from '@web3modal/ethers/vue';
import { BrowserProvider, FallbackProvider, JsonRpcProvider, Network } from 'ethers';
import { requestNetworkChange } from '~/utils/requsetNetworkChange';

export default () => {
  const { blockchain } = useEnvs();
  const { walletProvider } = useWeb3ModalProvider();

  const getProvider = () => {
    // TODO: move to constants file or create separate file for network definitions
    const bnb = new Network('Binance Smart Chain', blockchain.networkId);

    return new FallbackProvider(
      blockchain.nodeUrls.map((url) => {
        return {
          provider: new JsonRpcProvider(url, blockchain.networkId, { staticNetwork: bnb }),
          priority: 10,
          stallTimeout: 30_000,
          weight: 1
        };
      }),
      bnb,
      { quorum: 1 }
    );
  };

  const getSigner = async () => {
    if (!walletProvider.value) throw new Error('Wallet provider is not defined');
    const signer = await new BrowserProvider(walletProvider.value).getSigner();

    const result = await requestNetworkChange(signer, blockchain.networkId);
    if (result.changed) return await new BrowserProvider(walletProvider.value).getSigner();
    return signer;
  };

  return {
    getProvider,
    getSigner
  };
};
